export default __webpack_public_path__ + "static/media/ic_glp_custom.2e58e597.svg";